export const determineShowAssign = (isHovering, isActive, isLoading) =>
  isHovering || isActive || isLoading;
